import createVueApp from '../../shared/vue/create-app';
import initCustomControls from '../../components/custom-controls';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';

const initFAQPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                filter: '',
                openedQuestion: null,
                questionGroups: opts.model.groupedQuestions,
                isBuyLocationMode: true,
            };
        },
        methods: {
            showAnswer(question) {
                this.openedQuestion = this.openedQuestion === question ? null : question;
            },
            input(event) {
                this.filter = event.target.value;
            },
            filterQuestions(group) {
                const filteredAnswers = group.questionAnswers.filter((q) => {
                    q.isAnswerVisible = this.openedQuestion === q;
                    return q.question.toLowerCase().includes(this.filter.toLowerCase()) ||
                        q.answer.toLowerCase().includes(this.filter.toLowerCase());
                });
                group.isShown = filteredAnswers.length > 0;

                return filteredAnswers;
            },
        },
    });

    initCustomControls(app);
    initCustomInputsComponents(app);

    app.mount(opts.el);
};

export {initFAQPage};
